export const environment = {
  baseUrl: 'https://broadcastermobile-dev.domainscm.com/',
  customerJourneyUrl: 'https://journey.webhooksms.com/customer-journey/services/api/v1/',
  keycloakUrl: 'https://auth.ventachat.com',
  keycloakRealmName: 'ventaChat',
  keycloakClientId: 'user-venta',
  recaptcha: {
    siteKey: '6LdJixwqAAAAAH8NakePGz3g5-SNGQ1Cxplk3pJi',
  },
  url: 'https://app.ventachat.com',
  stompSocketUrl: "wss://app.ventachat.com/ws/venta-chat",
  stripeKey: "pk_live_51PgUAxKBHkjRBDaBAcWMSE41ReT5ClruYE454tIWPkGuyXFppWQDIEzjxE0aQWhghJPbJ0t8EKTyyhzZVI97Qfzp001cQfRI3K",
  customerId: '09a6dbd4-4006-4936-b2ce-1f926c6ff321',
  platformId: 'ventachat',
};
